import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
    CardHeader,
    ListGroup,
    ListGroupItem,
    CardFooter,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { getDataSpedRestrictionsByNMBahia } from "../../../../../slices/thunks";
import SimpleBar from "simplebar-react";

const Captaincy = ({ nmcapitania_id, nmbahia_id }) => {
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    // Redux Selector
    const selector = createSelector(
        (state) => state.DataSped,
        (result) => ({
            data: result.itemNMBahia,
            isSuccess: result.isDataSpedSuccess,
            isLoading: result.isDataSpedLoading,
        })
    );

    const { data, isLoading, isSuccess } = useSelector(selector);

    // Fetch Data on Component Mount
    useEffect(() => {
        if (nmbahia_id) {
            dispatch(getDataSpedRestrictionsByNMBahia(nmbahia_id));
        }
    }, [nmbahia_id]);

    const toggleModal = (item = null) => {
        setSelectedItem(item);
        setModal(!modal);
    };

    // Validación de datos y restricciones
    const restrictions = data?.restriction || [];

    if (nmbahia_id == null || !data) {
        return (
            <Card className='p-0 mb-2'>
                <CardHeader className='p-2 align-items-center d-flex'>
                    <h5 className="flex-grow-1 m-0">
                        <i className="ri-anchor-fill align-middle me-1 text-muted text-capitalize"></i>Capitanía de Puerto
                    </h5>
                </CardHeader>
                <CardBody className='p-2'>
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <div className="text-center">
                            <div className="avatar-md">
                                <span className="avatar-title bg-info-subtle rounded-circle fs-1">
                                    <i className="ri-ship-fill text-info"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </CardBody>
                <CardFooter className="m-0 p-2 text-center">
                    <h6 className="mb-0 p-0 text-wrap w-100">
                        <span className="fs-11 badge bg-info-subtle text-info text-wrap">
                        No cuenta con una capitanía de puerto
                        </span>
                    </h6>
                </CardFooter>
            </Card>
        );
    }

    return (
        <React.Fragment>
            <Card className='p-0 mb-2'>
                <CardBody className='p-2 align-items-center d-flex'>
                    <h5 className="flex-grow-1 m-0">
                        <i className="ri-anchor-fill align-middle me-1 text-muted text-capitalize"></i>{data?.NMCapitania}
                    </h5>
                    {restrictions.length > 1 && (
                        <span className="badge bg-danger ms-1">{restrictions.length}</span>
                    )}
                </CardBody>

                {restrictions.length > 0 ? (
                    restrictions.map((item, index) => (
                        <CardFooter key={index} className="m-0 p-2">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <ul className="list-unstyled mb-0 vstack gap-1">
                                        {[
                                            { label: "Bahía", value: item.GLBahia, badgeClass: "bg-info-subtle text-info" },
                                            { label: "Tipo Restricción", value: item.tiporestriccion, badgeClass: "bg-danger-subtle text-danger" },
                                            { label: "Restricción", value: item.MotivoRestriccion, badgeClass: "bg-danger-subtle text-danger" }
                                        ].map(({ label, value, badgeClass }, i) => (
                                            <li key={i}>
                                                <span className="text-muted">{label}</span>
                                                <span className="fw-semibold float-end">
                                                    <span className={`badge ${badgeClass}`}>{value}</span>
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="flex-shrink-0">
                                    <i
                                        className="icon-info text-danger"
                                        style={{ fontSize: "18px", cursor: "pointer" }}
                                        onClick={() => toggleModal(item)}
                                    />
                                </div>
                            </div>
                        </CardFooter>
                    ))
                ) : (
                    <CardFooter className="m-0 p-2 text-center">
                        <h6 className="mb-0 p-3 text-wrap w-100">
                            <span className="fs-11 badge bg-info-subtle text-info text-wrap">
                                No hay restricciones informadas
                            </span>
                        </h6>
                    </CardFooter>
                )}
            </Card>




            {/* Modal para mostrar detalles */}
            {selectedItem && (
                <Modal
                    isOpen={modal}
                    toggle={() => toggleModal()}
                    id="activity-modal"
                    size="lg"
                    className="border-0"
                    modalClassName="modal fade zoomIn"
                    backdrop="static"
                    centered={true}
                >
                    <ModalHeader toggle={() => toggleModal()}>
                        Detalle de Restricción
                    </ModalHeader>
                    <ModalBody>
                        <dl className="row mb-0 mt-3">
                            <dt className="col-sm-4 fw-bold mb-2">Bahía:</dt>
                            <dd className="col-sm-8"><span className="fs-10 badge bg-info-subtle text-info">{selectedItem.GLBahia}</span></dd>

                            <dt className="col-sm-4 fw-bold mb-2">INICIO FECHA/HR:</dt>
                            <dd className="col-sm-8">{selectedItem.FCinicio}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">FIN FECHA/HR:</dt>
                            <dd className="col-sm-8">{selectedItem.FCTermino || "N/A"}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">TIPO:</dt>
                            <dd className="col-sm-8">{selectedItem.tipo}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">NOMBRE INSTALACIÓN:</dt>
                            <dd className="col-sm-8">{selectedItem.NombreInstalacion}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">FRENTE ATRAQUE:</dt>
                            <dd className="col-sm-8">{selectedItem.FrenteAtraque}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">SITIO DE ATRAQUE:</dt>
                            <dd className="col-sm-8">{selectedItem.SitioAtraque}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">OBSERVACIÓN:</dt>
                            <dd className="col-sm-8">{selectedItem.Observacion}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">TIPO RESTRICCIÓN:</dt>
                            <dd className="col-sm-8"><span className="fs-10 badge bg-danger-subtle text-danger" style={{ wordBreak: "break-word" }}>{selectedItem.tiporestriccion}</span></dd>

                            <dt className="col-sm-4 fw-bold mb-2">ÁREAS DE RESTRICCIÓN:</dt>
                            <dd className="col-sm-8">{selectedItem.AreaRestriccion || "N/A"}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">MOTIVO DE RESTRICCIÓN:</dt>
                            <dd className="col-sm-8"><span className="fs-10 badge bg-danger-subtle text-danger">{selectedItem.MotivoRestriccion}</span></dd>

                            <dt className="col-sm-4 fw-bold mb-2">DETALLE:</dt>
                            <dd className="col-sm-8">{selectedItem.Detalle}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">NAVES CON RESTRICCIÓN:</dt>
                            <dd className="col-sm-8">{selectedItem.NaveRecibe}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">Nº NAVES MAYORES AFECTADAS EN RECALADA:</dt>
                            <dd className="col-sm-8">{selectedItem.nrecalada}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">Nº NAVES MAYORES AFECTADAS EN ZARPE:</dt>
                            <dd className="col-sm-8">{selectedItem.nzarpe}</dd>

                            <dt className="col-sm-4 fw-bold mb-2">Nº NAVES MAYORES AFECTADAS POR PARALIZACIÓN DE ACTIVIDADES:</dt>
                            <dd className="col-sm-8">{selectedItem.paralizar}</dd>
                        </dl>
                    </ModalBody>
                </Modal>
            )}
        </React.Fragment>
    );
};

export default Captaincy;
